<template>
    <div class="section01">
        <h3>재난안전</h3>
        <div class="calamity-box-wrap">
            <div class="box-wrap">
                <div class="calamity-box">
                    <strong>{{ safetyTypeMap['0'] ? safetyTypeMap['0'].length : '0' }}</strong>건
                    <p>재난</p>
                </div>
                <div class="calamity-box">
                    <strong>{{ safetyTypeMap['1'] ? safetyTypeMap['1'].length : '0' }}</strong>건
                    <p>화재</p>
                </div>
            </div>
            <button type="button" id="show-box01" class="button-box-more01"
				ref="show-safety-list-btn" @click.prevent="showMoreSafetyList(true)">목록 보기</button>
            <button type="button" id="hide-box01" class="button-box-close" style="display:none;"
				ref="hide-safety-list-btn" @click.prevent="showMoreSafetyList(false)">닫기</button>
            <ul class="list01 scroll" id="show-list01" ref="safety-list-ul">
                <template v-if="typeof safetyList !== 'undefined' && safetyList.length > 0">
                    <li v-for="(safety, index) in safetyList" :key="safety.registerNo">
                        <a href="#" @click.prevent="selectSafety(safety)">
                            <span class="label-box01-red">{{ safety.safetyCategory }}</span>
                            <p class="ellipsis" style="width:60%;">
                                {{ safety.shortAddress }}
                                {{ (safety.registerDay + safety.registerHms) | formatDate('yyyy-MM-dd HH:mm') }}
                            </p>
                            <span class="label-normal">{{ safety.processState }}</span>
                        </a>
                    </li>
                </template>
                <template v-else>
                    <li class="no-comment">
                        현재 발생 건이 없습니다.
                    </li>
                </template>
            </ul>
        </div>

        <transition name="modal">
            <SafetyInfoMapWin v-if="isShowSafetyInfoMapWin" :register-no="selectedSafetyRegisterNo" @close-safety-info-map-win="showSafetyInfoMapWin(false)" />
        </transition>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import SafetyInfoMapWin from "@/views/realtime/SafetyInfoMapWin.vue"

export default {
    name: 'SafetySummary',
    data() {
        return {
            isShowSafetyInfoMapWin: false,
            selectedSafetyRegisterNo: '',
        };
    },
    methods: {
        showSafetyInfoMapWin(isShow) {
            this.isShowSafetyInfoMapWin = isShow;
        },
        showMoreSafetyList(isShow) {
            if (isShow) {
                this.$refs['safety-list-ul'].style.display = "block";
				this.$refs['hide-safety-list-btn'].style.display = "";
				this.$refs['show-safety-list-btn'].style.display = "none";
            } else {
                this.$refs['safety-list-ul'].style.display = "none";
				this.$refs['hide-safety-list-btn'].style.display = "none";
				this.$refs['show-safety-list-btn'].style.display = "";
            }
        },
        selectSafety(safety) {
            this.selectedSafetyRegisterNo = safety.registerNo;
            this.showSafetyInfoMapWin(true);
        },
    },
    computed: {
        ...mapGetters({
            safetyList: 'getSafetyList',
            safetyTypeMap: 'getSafetyTypeMap',
        })
    },
    components: {
        SafetyInfoMapWin,
    },
}
</script>